// extracted by mini-css-extract-plugin
export default {"info-action":"InfoAction_info-action__hnaXP","row":"InfoAction_row__ECJFy","col-2":"InfoAction_col-2__3reOA","button-buy-report":"InfoAction_button-buy-report__goKzX"};